import { ErrorStateType } from '@models';
import { ErrorActionTypes, SET_ERROR, CLEAR_ERRORS } from '@store/types/error';

export const setError = (error: ErrorStateType): ErrorActionTypes => ({
  type: SET_ERROR,
  payload: error,
});

export const clearErrors = (): ErrorActionTypes => ({
  type: CLEAR_ERRORS,
  payload: undefined,
});
